import {
  OTHER_PATIENTS_FAILURE,
  OTHER_PATIENTS_REQUEST,
  OTHER_PATIENTS_SUCCESS,
  UPDATE_OTHER_PATIENT_LIST,
} from '../actions/actionTypes';

const initialState = {
  otherPatientList: [],
  isFetchingOtherPatientList: false,
  isErrorInOtherPatientList: null,
};

const otherPatient = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  } else {
    switch (action.type) {
      case OTHER_PATIENTS_REQUEST:
        return {
          ...state,
          isFetchingOtherPatientList: true,
          isErrorInOtherPatientList: null,
        };
      case OTHER_PATIENTS_SUCCESS:
        return {
          ...state,
          isFetchingOtherPatientList: false,
          otherPatientList: action.payload,
          isErrorInOtherPatientList: null,
        };
      case OTHER_PATIENTS_FAILURE:
        return {
          ...state,
          isFetchingOtherPatientList: false,
          isErrorInOtherPatientList: 'SomeThing went wrong.',
        };
      case UPDATE_OTHER_PATIENT_LIST:
        return {
          ...state,
          isFetchingOtherPatientList: false,
          isErrorInOtherPatientList: null,
          otherPatientList: action.payload,
        };
      default:
        return state;
    }
  }
};

export default otherPatient;
